import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IProjectJobNumberFields {
		id?: any;
		contractManagerId?: any;
		sysproJobNo?: any;
		status?: any;
		datestamp?: any;
		changedBy?: any;
		siteId?: any;
		custPrefix?: any;
		custName?: any;
		branch?: any;
		sisproTimestamp?: any;
		sisproTimestampExt?: any;
}

export class ProjectJobNumberFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public contractManagerId: IEntityModelField = { name: "contractManagerId", displayName: "Contract Manager Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public sysproJobNo: IEntityModelField = { name: "sysproJobNo", displayName: "SYSPROJob No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public changedBy: IEntityModelField = { name: "changedBy", displayName: "Changed By", fieldType: FieldType.String, pattern: "NameGeneric" };
	public siteId: IEntityModelField = { name: "siteId", displayName: "Site Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public custPrefix: IEntityModelField = { name: "custPrefix", displayName: "Cust Prefix", fieldType: FieldType.String, pattern: "NameGeneric" };
	public custName: IEntityModelField = { name: "custName", displayName: "Cust Name", fieldType: FieldType.String, pattern: "NameGeneric" };
	public branch: IEntityModelField = { name: "branch", displayName: "Branch", fieldType: FieldType.String, pattern: "NameGeneric" };
	public sisproTimestamp: IEntityModelField = { name: "sisproTimestamp", displayName: "Sispro Timestamp", fieldType: FieldType.String, pattern: "NameGeneric" };
	public sisproTimestampExt: IEntityModelField = { name: "sisproTimestampExt", displayName: "Sispro Timestamp Ext", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.contractManagerId);
		this.push(this.sysproJobNo);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.siteId);
		this.push(this.custPrefix);
		this.push(this.custName);
		this.push(this.branch);
		this.push(this.sisproTimestamp);
		this.push(this.sisproTimestampExt);
	}
}

export class ProjectJobNumberDTO implements IEntityModel {
	protected projectJobNumberName: string = "ProjectJobNumberModel";
	protected projectJobNumberKeyField: string = "id";
	protected projectJobNumberDisplayName: string = "Project Job Number|Project Job Numbers";
	protected projectJobNumberFields = new ProjectJobNumberFields();
	public get name(): string { return this.projectJobNumberName };
	public get keyField(): string { return this.projectJobNumberKeyField };
	public get displayName(): string { return this.projectJobNumberDisplayName };
	public get fields(): ProjectJobNumberFields { return this.projectJobNumberFields };

	constructor() {};
}
